import { useState } from 'react';

import { useAccountSelector } from 'src/hooks';
import { IdentityVerificationInstructions, MFormSection } from 'src/lib';
import { AccountHolder } from 'src/models';

import { PersonalInformationForm } from './PersonalInformationForm';
import { PersonalInformationView } from './PersonalInformationView';

interface OtherAccountHolderSectionProps {
  accountHolder: AccountHolder;
}

export const OtherAccountHolderSection = ({ accountHolder }: OtherAccountHolderSectionProps) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  return (
    <MFormSection
      title='Personal Information'
      onEdit={onEdit}
      isEditable
      isEditMode={isEditMode}
      tooltip={{
        icon: 'info',
        title: 'Identity Verification Instructions',
        label: 'Please enter your name as shown on a government-issued ID',
        type: 'modal',
        content: <IdentityVerificationInstructions />,
      }}
      testId={'other-personal-information'}>
      {!isEditMode ? (
        <PersonalInformationView accountHolder={accountHolder} isPrimary={false} />
      ) : (
        <PersonalInformationForm
          accountHolder={accountHolder}
          accountId={account?.accountId}
          accountUuid={account?.id}
          accountType={account?.type.value}
          isPrimary={false}
          onCancel={onCancel}
          testId={'other-account-holder-section'}
        />
      )}
    </MFormSection>
  );
};
